// This key must match the one in the monolith until all trail page views are directed to mugen
// https://github.com/alltrails/alltrails/blob/4e752b570568c92443f109615334f29fbf6fb53f/app/controllers/trails_controller.rb#L24
export const pageViewCookie = 'trail_count';
export const pageViewLimit = 1;
